import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NbCheckboxModule, NbIconModule, NbInputModule, NbSpinnerModule, NbToggleModule} from '@nebular/theme';
import {SortPipe} from 'compob2b-libs';

import {BaseComponent} from 'compob2b-table';

import {NgxPaginationModule} from 'ngx-pagination';

import {GlobalSearchPipe} from '../../pipes/global-search-pipe';
import {RenderPipe} from '../../pipes/render-pipe';
import {SearchPipe} from '../../pipes/search-pipe';

import {HeaderComponent} from '../header/header.component';
import {PaginationComponent} from '../pagination/pagination.component';
import {TableTHeadComponent} from '../thead/thead.component';

@NgModule({
  declarations: [
    BaseComponent,
    HeaderComponent,
    PaginationComponent,
    TableTHeadComponent,

    // Pipes
    SearchPipe,
    RenderPipe,
    GlobalSearchPipe,
  ],
  // RouterModule — для ссылок страниц пейджера в режиме `linkPages`.
  imports: [CommonModule, RouterModule, NgxPaginationModule, DragDropModule, ScrollingModule, NbIconModule, NbCheckboxModule, NbToggleModule, NbInputModule, SortPipe, NbSpinnerModule],
  exports: [BaseComponent, PaginationComponent, RenderPipe],
})
export class BaseModule {
}
